<template>
  <Content id="users">
    <div slot="search">
      <Form :label-width="70" :model="search">
        <Row>
          <Col>
            <FormItem label="用户名">
              <Input v-model="search.name" style="width:120px;"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width:100px;">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="handleDataList">搜索</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button type="primary" size="small" icon="md-add" @click="handleCreate">添加</Button>
        </div>
      </div>

    </div>

    <ITable ref="list" stripe :columns="columns" :loading="list.loading" :data="list.data" :total="list.total"
            @on-page-change="handleDataList" @on-selection-change="handleSelectionChange" />

    <UserEdit ref="edit" :roles="roles" @on-update="handleDataList" />

  </Content>
</template>
<script>
import {
  _delUser, // 删除
  _getUserList // 列表
} from "@/services/manage/users";
import {
  _getAllRole
} from "@/services/manage/roles";
import UserEdit from "./UserEdit";
export default {
  name: "Users",
  components: {
    UserEdit
  },
  data() {
    return {
      search: {
        name: "",
        status: ""
      },
      roles :[],
      list: {
        data: [],
        total: 0,
        loading: false
      },
      statusList: [
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      columns: [
        {
          title: "用户名",
          key: "name",
          minWidth: 80
        },
        {
          title: "真实姓名",
          key: "realName",
          minWidth: 80
        },
        {
          title: "角色",
          key: "roleName",
          minWidth: 80,
        },
        {
          title: "操作员",
          key: "operator",
          minWidth: 80
        }, {
          title: "创建时间",
          key: "createTime",
          minWidth: 100
        }, {
          title: "状态",
          key: "status",
          minWidth: 60,
          render: (h, params) =>
            h('span', params.row.status === 1 ? "启用" : "禁用")
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          fixed: "right",
          minWidth: 150,
          render: (h, params) => this.$Utils.operatorBtn_FORMAT(h,params,
            {
              type: 'edit',
              confirm: false,
              callback: this.handleEdit
            },
            {
              type: 'delete',
              confirm: true,
              callback: this.handleRemove
            }
          )
        }
      ]
    };
  },
  mounted() {
    this.applyAllRoles();
    this.handleDataList(); // 获取列表数据
  },
  methods: {
    /**
     * 获取所有角色
     * */
    async applyAllRoles(){
      const res = await _getAllRole({tenantId: ''});
      try {
        let newArr = []
        res.data.forEach(item=>{
          newArr.push({
            label: item.name,
            value: parseInt(item.id)
          })
        })
        this.roles= newArr;
        return  newArr;
      }catch (e) {
        console.log(e,'报错')
      }

    },
    /**
     * 获取用户列表
     * @param  {string} type 是否使用搜索, 默认值 undefined (不使用搜索)
     */
    handleDataList(type) {
      this.$Loading.start();
      this.list.loading = true; // 列表加载状态
      const page = this.$refs["list"].handlePage(type); // 获取分页信息
      _getUserList({
        ...this.search,
        currentPage: page.current,
        pageSize: page.pageSize
      }).then(res => {
        this.$Loading.finish();
        const { records, total } = res.data;
        console.log(res.data, 'res.data')
        this.list = {
          data: records,
          total: total,
          loading: false
        };
      })
        .catch(() => {
          this.$Loading.error();
          this.list.loading = false;
        });
    },
    // 新增界面
    async handleCreate() {
      const res = await this.applyAllRoles();
      console.log("roles.findAll",res);
      this.$refs["edit"].handleModal(true,"新增用户"); // 显示创建模态框
    },
    /**
     * 编辑界面
     * @param  {object} row 当前行数据
     */
    handleEdit(row) {
      this.$refs["edit"].handleModal(false,"用户编辑", row); // 显示编辑模态框
    },
    /**
     * 删除用户
     * @param  {object} row 当前行数据
     */
    handleRemove(row) {
      this.$Loading.start();
      this.list.loading = true;
      // 模拟异步请求(删除)
      setTimeout(() => {
        _delUser({
          id: row.id
        })
          .then(res => {
            this.$message.success(res.errmsg);
            this.handleDataList();
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    /**
     * 在多选模式下有效，只要选中项发生变化时就会触发
     * @param  {array} selection 已选项数据
     */
    handleSelectionChange(selection) {
      const ids = [];
      for (const item of selection) {
        ids.push(item["id"]);
      }
      this.toolbar = {
        ids: ids,
        number: selection.length
      };
    },
  }
};
</script>
<style lang="postcss" scoped>
.toolbar {
  margin-bottom: 24px;
  text-align: right;

  & .number {
    margin-right: 8px;
  }
}
</style>
